import { action, makeObservable, observable } from 'mobx';

import { AbstractStore } from 'stores/abstract';

class ServiceScheduleStoreC extends AbstractStore {
  selectedEventToSeeDetails = null;
  selectedEventToSeeSuggestions = null;

  onClickRescheduleRequiredEventDetails(event) {
    this.selectedEventToSeeDetails = event;
  }

  onClickRescheduleRequiredSuggestedRescheduleDates(event) {
    this.selectedEventToSeeSuggestions = event;
  }
  constructor() {
    super();
    makeObservable(this, {
      onClickRescheduleRequiredEventDetails: action,
      onClickRescheduleRequiredSuggestedRescheduleDates: action,
      selectedEventToSeeDetails: observable,
      selectedEventToSeeSuggestions: observable,
    });
  }
}

const ServiceScheduleStore = new ServiceScheduleStoreC();
export default ServiceScheduleStore;
